import React from 'react';

export const CommunicationPreferenceMessages = {
    canSMS: <>
        I agree to receive text messages about my pet&rsquo;s vet services. Texts may be made using automated telephone dialing systems.
        <br></br>Terms available <a
            target="_blank" rel="noreferrer noopener"
            className='link-revert'
            href="https://www.petco.com/content/petco/PetcoStore/en_US/pet-services/terms-of-use/sms-terms-conditions.html">
            here.
        </a>&nbsp;
        <strong><u>
            Please note, if you opt out of these communications, it may affect our ability to communicate with you regarding your pet&rsquo;s test results, pick-up instructions, post-surgical follow-up, emergencies, and wellness recommendations.
        </u></strong>
        &nbsp;Not a condition for purchase.<br></br>
    </>,
    canCall: <>
        I agree to receive calls about my pet&rsquo;s vet services. Calls may be made using automated telephone dialing systems.
        <br></br>Terms available <a
            target="_blank" rel="noreferrer noopener"
            className='link-revert'
            href="https://www.petco.com/content/petco/PetcoStore/en_US/pet-services/terms-of-use/sms-terms-conditions.html">
            here.
        </a>&nbsp;
        <strong><u>
            Please note, if you opt out of these communications, it may affect our ability to communicate with you regarding your pet&rsquo;s test results, pick-up instructions, post-surgical follow-up, emergencies, and wellness recommendations.
        </u></strong>
        &nbsp;Not a condition for purchase.<br></br>
    </>
}
